<template>
  <SkeletonTheme :color="isDarkMode ? '#444444' : '#eeeeee'">
    <div class="realtime-rank">
      <div class="rank-column">
        <div v-if="isLoading" style="padding: 0 5px">
          <PuSkeleton :count="halfCount" />
        </div>
        <div v-else v-for="(item, index) in left" :key="`rank-left-${index}`">
          <RankItem :item="item" />
        </div>
      </div>
      <div class="rank-column">
        <div v-if="isLoading" style="padding: 0 5px">
          <PuSkeleton :count="halfCount" />
        </div>
        <div v-else v-for="(item, index) in right" :key="`rank-right-${index}`">
          <RankItem :item="item" />
        </div>
      </div>
    </div>
  </SkeletonTheme>
</template>

<script>
import RankItem from "@/components/news/RankItem"
import { SkeletonTheme } from "vue-loading-skeleton"
import { mapGetters } from "vuex"
export default {
  components: {
    RankItem,
    SkeletonTheme
  },
  props: ["rankItem", "isLoading"],
  data() {
    return {
      left: [],
      right: []
    }
  },
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" }),
    halfCount() {
      return this.rankItem.length / 2
    }
  },
  watch: {
    rankItem() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.left = []
      this.right = []
      const length = this.rankItem.length
      for (let i = 0; i < length; i++) {
        this.rankItem[i].src = "https://search.naver.com/search.naver?where=news&sm=tab_jum&query=" + this.rankItem[i].keyword
        this.rankItem[i].msrc = "https://m.search.naver.com/search.naver?where=m_news&query=" + this.rankItem[i].keyword
        if (i < length / 2) {
          this.left.push(this.rankItem[i])
        } else {
          this.right.push(this.rankItem[i])
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.realtime-rank {
  display: flex;
  margin-left: -10px;
  margin-top: 10px;
  max-width: 1024px;
  min-height: 150px;

  @include small-mobile {
    flex-direction: column;
  }
}
.rank-column {
  width: 50%;
  @include small-mobile {
    width: 100%;
  }
}
</style>
